import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent implements OnInit {
  isSizeMobile = false;
  buttonPages!: (number | string)[];
  @Input() currentPage!: number;
  @Input() totalPages!: number;
  @Output() pageChange = new EventEmitter<number>();

  constructor(private breakpointObserver: BreakpointObserver) {}

  async ngOnInit(): Promise<void> {
    window.scrollTo(0, 0);
    const oritentation = this.breakpointObserver.observe([
      '(max-width: 768px)',
    ]);
    oritentation.subscribe((lay) => {
      this.isSizeMobile = lay.breakpoints['(max-width: 768px)'];
    });
    await this.getNumberPagesPaginator(this.currentPage, this.totalPages);
  }

  async getNumberPagesPaginator(start: number, end: number) {
    let totalPages = end - start + 1;

    if (start === end) {
      totalPages = end;
      if (totalPages <= 3) {
        start = 1;
        this.buttonPages = Array.from(
          { length: totalPages },
          (_, index) => start + index,
        );
      } else {
        start = start - 2;
        this.buttonPages = Array.from(
          { length: 3 },
          (_, index) => start + index,
        );
      }
    }

    if (totalPages > 1 && totalPages <= 4 && start !== end) {
      // Menos o igual 4 páginas, mostrar todas las páginas
      this.buttonPages = Array.from(
        { length: totalPages },
        (_, index) => start + index,
      );
    } else if (totalPages > 4 && start !== end) {
      // Más de 4 páginas, mostrar las primeras 3

      const firstThreePages = Array.from(
        { length: 3 },
        (_, index) => start + index,
      );

      this.buttonPages = [...firstThreePages];
    }
  }

  goToPagePaginator(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.pageChange.emit(page);
    }
  }

  nextPagePaginator() {
    this.goToPagePaginator(this.currentPage + 1);
    if (this.currentPage <= this.totalPages - 1) {
      this.getNumberPagesPaginator(this.currentPage + 1, this.totalPages);
    }
  }

  prevPagePaginator() {
    this.goToPagePaginator(this.currentPage - 1);
    if (
      this.currentPage - 1 <= this.totalPages - 3 &&
      this.currentPage - 1 !== 0
    ) {
      this.getNumberPagesPaginator(this.currentPage - 1, this.totalPages);
    }
  }

  firstPagePaginator() {
    this.goToPagePaginator(1);
    this.getNumberPagesPaginator(1, this.totalPages);
  }

  lastPagePaginator() {
    this.goToPagePaginator(this.totalPages);
    if (this.totalPages > 4) {
      this.getNumberPagesPaginator(this.totalPages - 3, this.totalPages);
    }
  }

  onPageChangePaginator(page: string | number) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.currentPage = Number(page);
    this.pageChange.emit(Number(page));
  }
}
